import { ComparatorStep } from '@kizi/comparator-core';
import triplePlayProvvalueerOptions from '../content/triplePlayProviderOptions';

const notMoving = {
  name: 'isMove',
  active: true,
  condition: { fn: 'isNotEqual', args: ['true'] },
};
const isMoving = {
  name: 'isMove',
  active: true,
  condition: { fn: 'isNotEqual', args: ['false'] },
};

const fullAddressIsNotUndefined = {
  name: 'fullAddress',
  active: true,
  condition: {
    fn: 'isNotEqual',
    args: [undefined],
  },
};

const fullAddressIsNotEmptyString = {
  name: 'fullAddress',
  active: true,
  condition: {
    fn: 'isNotEqual',
    args: [''],
  },
};

const addressFields = [
  {
    name: 'postcode',
    active: true,
    validator: [
      {
        fn: 'nullableRegex',
        args: [
          'Deze postcode kennen we helaas niet. Vul ajb 4 cijfers en 2 letters in.',
          '^[0-9]{4}[a-z]{2}$',
          'i',
        ],
      },
      {
        fn: 'required',
        args: ['Dit veld is verplicht.'],
      },
    ],
    transformers: ['removeSpaces', 'uppercase'],
  },
  {
    name: 'housenumber',
    active: true,
    validator: [
      {
        fn: 'required',
        args: ['Voer een geldig huisnummer in'],
      },
      {
        fn: 'houseNumberIsValid',
        args: [
          'Deze combinatie van postcode/huisnummer kennen we helaas niet.',
        ],
      },
    ],
    transformers: {
      fn: 'replaceWith',
      args: ['[^0-9-]+', ''],
    },
  },
  {
    name: 'housenumberaddition',
  },
  {
    name: 'houseNumberWithAddition',
    active: true,
  },
  {
    name: 'street',
    active: true,
    validator: 'required',
  },
  {
    name: 'city',
    active: true,
    validator: 'required',
  },
  {
    name: 'fullAddress',
    active: true,
    validator: 'required',
  },
];

const modalSteps = [
  {
    name: 'internet',
    fields: [
      {
        name: 'downloadSpeed',
      },
    ],
  },
  {
    name: 'television',
    fields: [
      {
        name: 'decoders',
      },
      {
        name: 'withRecorder',
      },
      {
        name: 'extraChannelPackage',
      },
      {
        name: 'specificTvChannel',
      },
      {
        name: 'specificTvChannelOptions',
      },
    ],
  },
  {
    name: 'call',
    fields: [
      {
        name: 'bellen',
      },
    ],
  },
  {
    name: 'combinationDiscount',
    fields: [
      {
        name: 'mobileProvider',
      },
      {
        name: 'energySupplier',
      },
      {
        name: 'mobileProviderOptions',
      },
    ],
  },
];

const startWidget: ComparatorStep = {
  path: 'start',
  name: 'startWidget',
  fields: [
    {
      name: 'modalSteps',
      value: JSON.stringify(modalSteps),
    },
    ...addressFields,
    {
      name: 'productTypes',
      active: true,
      label: 'Stel je pakket samen',
      validator: {
        fn: 'isArrayLengthGreater',
        args: [0, 'Dit veld is verplicht.'],
      },
      value: JSON.stringify(['internet', 'television']),
    },
    {
      name: 'isMove',
      active: true,
      validator: {
        fn: 'required',
        args: ['Dit veld is verplicht.'],
      },
      value: 'false',
    },
    {
      name: 'currentProvider',
      active: false,
      dependsOn: [
        {
          ...notMoving,
          active: true,
          validator: {
            fn: 'required',
            args: ['Kies je huidige provider'],
          },
        },
        {
          ...isMoving,
          value: '',
          active: false,
        },
      ],
    },
    {
      name: 'providerOptions',
      value: JSON.stringify(triplePlayProvvalueerOptions),
    },
    {
      name: 'decisionAid',
      active: false,
      dependsOn: [
        {
          conditions: [fullAddressIsNotUndefined, fullAddressIsNotEmptyString],
          active: true,
        },
      ],
    },
  ],
};

export default startWidget;
